import type { ReactNode, SVGProps } from "react";

export function StatusIcon(props: SVGProps<SVGSVGElement>): ReactNode {
	return (
		<svg
			fill="none"
			height="14"
			viewBox="0 0 14 14"
			width="14"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M5.24112 12.6253C4.65678 12.4903 4.09558 12.2671 3.57617 11.9629"
				stroke="black"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M7.92676 0.625244C9.26151 0.935646 10.4532 1.69828 11.3068 2.78829C12.1603 3.87829 12.6252 5.23108 12.6252 6.62517C12.6252 8.01927 12.1603 9.37206 11.3068 10.4621C10.4532 11.5521 9.26151 12.3147 7.92676 12.6251"
				stroke="black"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M1.60207 10.1068C1.23585 9.56507 0.957705 8.96679 0.77832 8.33496"
				stroke="black"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M0.625 5.59986C0.732416 4.95045 0.939192 4.33521 1.22922 3.77124L1.34267 3.56274"
				stroke="black"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M3.16504 1.5522C3.79319 1.1119 4.49789 0.797317 5.24153 0.625244"
				stroke="black"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M4.56982 6.62525L5.91253 7.99244L8.59793 5.25806"
				stroke="black"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
		</svg>
	);
}
